import api from "./api";

/** Institute-scoped promotion / enrollment-change log (teachers see their class scope only). */
export const getInstitutePromotionLog = (params = {}) =>
  api.get("/student-promotion/institute-history", { params });

export const getInstitutePromotionLogDetails = (historyId, params = {}) =>
  api.get(`/student-promotion/institute-history/${historyId}/details`, { params });

export default { getInstitutePromotionLog };
